<template>
  <div>
    <!-- <img
      class="banner"
      src="@/assets/images/jiameng/banner.jpg"
      v-if="userInfo.level == 1"
    />
    <img
      class="banner"
      src="@/assets/images/jiameng/banner2.jpg"
      v-if="userInfo.level == 2"
    /> -->
    <div class="section-title" v-if="userInfo.spread_uid">我的上级</div>
    <div class="bgc-w" v-if="userInfo.spread_uid">
      <div
        class="fx fx-align-center"
        style="line-height: 50px; padding-bottom: 4px;"
      >
        <div class="ta-c" style="width: 100px;">昵称/简称</div>
        <div class="fx-1">
          {{ userInfo.parent && userInfo.parent.nickname }}
        </div>
      </div>
      <div
        class="fx fx-align-center"
        style="line-height: 50px;padding-bottom: 4px;"
        v-if="userInfo.parent && userInfo.parent.phone"
      >
        <div class="ta-c" style="width: 100px;">手机号码</div>
        <div class="fx-1">
          {{ userInfo.parent && userInfo.parent.phone }}
        </div>
      </div>
    </div>

    <div class="section-title">我的信息</div>
    <div class="bgc-w mb-12" style="margin-bottom: 12px;">
      <div
        class="fx fx-align-center"
        style="line-height: 50px;padding-bottom: 4px;"
      >
        <div class="ta-c" style="width: 100px;">昵称/简称</div>
        <div class="fx-1">{{ userInfo.nickname }}</div>
      </div>
      <div
        class="fx fx-align-center"
        style="line-height: 50px;padding-bottom: 4px;"
      >
        <div class="ta-c" style="width: 100px;">会员等级</div>
        <div class="fx-1">{{ userInfo.level | showLevel }}</div>
      </div>
      <div
        class="fx fx-align-center"
        style="line-height: 50px;padding-bottom: 4px;"
        v-if="userInfo.phone"
      >
        <div class="ta-c" style="width: 100px;">手机号码</div>
        <div class="fx-1">{{ userInfo.phone }}</div>
      </div>
    </div>

    <div style="margin-bottom: 100px;" v-if="userInfo.level < 3">
      <div class="bgc-w" style="margin-bottom: 12px;">
        <div class="section-title ta-c">加盟费用</div>
        <div
          class="ta-c"
          style="font-size: 44px;padding-bottom: 16px;line-height: 1;"
        >
          {{ joinFee }}
        </div>
      </div>
      <div class="" style="padding: 0 12px;">
        <button
          class="btn btn-big btn-orange click--active"
          type="default"
          @click="pay"
        >
          确定支付
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { upgradeToNet, upgradeToDev } from "@api/user";
import payMixin from "@components/payMixin";

export default {
  data() {
    return {
      // from: isWeixin() ? "weixin" : "weixinh5"
    };
  },

  mixins: [payMixin],

  computed: {
    userInfo() {
      return this.$route.query.userInfo || {};
    },
    joinFee() {
      if (this.userInfo.level == 1) return "￥200.00";
      if (this.userInfo.level == 2) return "￥2000.00";
      return "";
    }
  },

  created() {
    this.computeTitle();
  },

  filters: {
    showLevel(level) {
      if (level == 1) return "普通会员";
      if (level == 2) return "网点会员";
      if (level == 3) return "创业合伙人";
    }
  },

  methods: {
    computeTitle() {
      let title = "加盟";
      const { level } = this.$route.query.userInfo || {};
      if (level == 1) title = "加盟为网点";
      if (level == 2) title = "加盟为创业合伙人";
      document.title = title;
    },

    pay() {
      this.submit();
    },

    // 微信支付, 根据升级的级别，自动判断提交的地址
    submit() {
      let upgradeRequest;
      const { level } = this.$route.query.userInfo || {};
      if (level == 1) upgradeRequest = upgradeToNet;
      if (level == 2) upgradeRequest = upgradeToDev;
      upgradeRequest()
        .then(res => {
          let payPackage = res.data;
          // 通过支付包调起微信支付
          return this.weiXinJsApi({
            appId: payPackage.appId, //公众号名称，由商户传入
            timeStamp: payPackage.timestamp + "", //时间戳
            nonceStr: payPackage.nonceStr, //随机串
            package: payPackage.package,
            signType: payPackage.signType, //微信签名方式：
            paySign: payPackage.paySign //微信签名
          });
        })
        .then(() => {
          setTimeout(() => {
            this.$router.go(-1);
          }, 300);
        })
        .catch(err => console.log(err, "error"));
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  max-height: 260px;
  background: #eee;
}
.section-title {
  font-size: 16px;
  line-height: 34px;
  padding: 0 12px;
}
//flex布局
.fx {
  display: flex;
}

.inline-fx {
  display: inline-flex;
}

.fx-v {
  flex-direction: column;
}

.fx-1 {
  flex: 1 1 auto;
}

.fx-1-0 {
  flex: 1 0 auto;
}

.fx-n {
  flex: 0 0 auto;
}

.fx-align-start {
  align-items: flex-start;
}

.fx-align-center {
  align-items: center;
}

.fx-align-end {
  align-items: flex-end;
}

.fx-justify-center {
  justify-content: center;
}

.fx-justify-end {
  justify-content: flex-end;
}

.fx-justify-between {
  justify-content: space-between;
}

.fx-justify-around {
  justify-content: space-around;
}
.fx-wrap {
  flex-wrap: wrap;
}

/* 按钮操作 */
.btn {
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-left: 14px;
  padding-right: 14px;
  font-size: 16px;
  text-align: center;
  text-decoration: none;
  line-height: 2.5;
  border-radius: 4px;
  border: 1px solid #dedede;
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
  color: #525252;
  background-color: #f8f8f8;
  user-select: none;
}

.btn[disabled] {
  opacity: 0.5 !important;
}

.btn-mini {
  display: inline-block;
  line-height: 1;
  padding: 8px 10px;
  border-radius: 2px;
}
.ta-c {
  text-align: center;
}

.btn-big {
  width: 100%;
}

.btn-orange {
  border-color: #ff6701 !important;
  background: #ff6701 !important;
  color: #fff !important;
}

/* 交互反馈 */

.click--active:active {
  // -webkit-filter: brightness(0.8) !important;
  // filter: brightness(0.8) !important;
  opacity: 0.6 !important;
}
</style>
